const iconTableInfoDataset =[
  // rule for icons... icons are for ongoing notifications only!!
  {
    iconName: "negativeNetIncome",
        iconCategory: "warning",
        className: "small_sign_thumbnail_img warning-sign-position",
        imageSrc: "warningSign1.png",
        firstTime: true,
  },
  {
    iconName: "negativeCash",
        iconCategory: "warning",
        className: "small_sign_thumbnail_img warning-sign-position",
        imageSrc: "warningSign0.png",
        firstTime: true,
  },
  {
    iconName: "negativeMoodPoints",
        iconCategory: "warning",
        className: "small_sign_thumbnail_img warning-sign-position2",
        imageSrc: "moodFaceSad.png",
        firstTime: true,
  },
  {
    iconName: "pendingJob",
        iconCategory: "goodNews",
        className: "small_sign_thumbnail_img good-news-college-position",
        imageSrc: "CollegeSign.png",
        firstTime: true,
  },
  {
    iconName: "funStuff",
        iconCategory: "goodNews",
        className: "small_sign_thumbnail_img good-news-funStuff-position",
        imageSrc: "FunStuff.jpg",
        firstTime: true,
  },
  {
    iconName: "funStuffReminder",
        iconCategory: "goodNews",
        className: "small_sign_thumbnail_img good-news-funStuff-position",
        imageSrc: "FunStuff.jpg",
        firstTime: true,
   },
  {
    iconName: "moneyBuilder",
        iconCategory: "goodNews",
        className: "small_sign_thumbnail_img good-news-moneyBuilder-position",
        imageSrc: "moneyBuilder.jpg",
        firstTime: true,
  },
  {
    iconName: "savingsGTIncome",
        iconCategory: "warning",
        className: "small_sign_thumbnail_img warning-sign-position3",
        imageSrc: "WarningSign2.png",
        firstTime: true,
  },
  {
    iconName: "savingsTransfer",
        iconCategory: "warning",
        className: "small_sign_thumbnail_img warning-sign-position",
        imageSrc: "WarningSign3.png",
        firstTime: true,
  },
  {
    iconName: "creditCard",
        iconCategory: "goodNews",
        className: "small_sign_thumbnail_img good-news-creditCard-position",
        imageSrc: "creditCard.png",
        firstTime: true,
  },
  {
    iconName: "creditLimitExceeded",
        iconCategory: "warning",
        className: "small_sign_thumbnail_img warning-sign-position3",
        imageSrc: "WarningSign2.png",
        firstTime: true,
  },
  {
    iconName: "creditCardDenied",
        iconCategory: "warning",
        className: "small_sign_thumbnail_img warning-sign-position3",
        imageSrc: "WarningSign2.png",
        firstTime: true,
  },
  {
    iconName: "insufficientCash",
        iconCategory: "warning",
        className: "small_sign_thumbnail_img warning-sign-position3",
        imageSrc: "WarningSign2.png",
        firstTime: true,
  },
  {
    iconName: "purchaseAHome",
        iconCategory: "goodNews",
        className: "small_sign_thumbnail_img good-news-house-position",
        imageSrc: "house.png",
        firstTime: true,
  },
  {
    iconName: "takeMoneyMgmtTest",
        iconCategory: "information",
        className: "small_sign_thumbnail_img good-news-takeTest-position",
        imageSrc: "takingTest.png",
        firstTime: true,
  },
  {
    iconName: "timeWizard",
        iconCategory: "goodNews",
        className: "small_sign_thumbnail_img good-news-timeWizard-position",
        imageSrc: "timeWizard.png",
        firstTime: true,
  },
  {    
    iconName: "investPayout",
        iconCategory: "goodNews",
        className: "small_sign_thumbnail_img good-news-investments-position",
        imageSrc: "investments.png",
        firstTime: true,
  },

   {    
    iconName: "protectionPlan",
        iconCategory: "information",
        className: "small_sign_thumbnail_img notification-insurance-position",
        imageSrc: "shield.png",
        firstTime: true,
  },
 
];

export default iconTableInfoDataset;